import { EnrichedPlan } from "@/types/billingPlans";

export const customOptimizePlan: EnrichedPlan = {
  "accessToProviders": false,
  "additionalPrices": {
    "MY": {
      "amount": 0,
      "currency": "MYR",
      "id": ""
    },
    "SG": {
      "amount": 0,
      "currency": "SGD",
      "id": ""
    },
    "US": {
      "amount": 0,
      "currency": "USD",
      "id": ""
    }
  },
  "allowedUpgradeTo": [
    "prod_OMrpirp5TCKUoQ",
    "prod_ONch5WG8S2gEoj",
    "prod_OPTFh0rT4vO3p2"
  ],
  "autoDispatch": true,
  "automatedNotifications": true,
  "brandedTrackingPage": false,
  "liveDeliveryTracking": true,
  "customSolutions": true,
  "description": "",
  "everythingInGrow": true,
  "everythingInLaunch": false,
  "maxFiveDrivers": true,
  "growFeatures": false,
  "id": "custom",
  "isSubscribed": false,
  "key": "optimization",
  "icon": "/assets/images/plansSettings/scale.svg",
  "launchFeatures": false,
  "driverApp": true,
  "multiStops": false,
  "name": "Optimize",
  "optimizationAndBatching": false,
  "orderQuotes": 0,
  "orderQuotesDescription": 3000,
  "ownCouriersAccounts": true,
  "ownDrivers": true,
  "premiumOnboarding": true,
  "price": {
    "amount": 0,
    "currency": "SGD",
    "id": "price_1NaqA8D2hzVtG51xjsFbAvf0"
  },
  "prices": {
    "EUR": {
      "amount": 0,
      "currency": "EUR",
      "id": "price_1OA6acD2hzVtG51x27ewhKTb"
    },
    "MY": {
      "amount": 0,
      "currency": "MYR",
      "id": "price_1NaqCTD2hzVtG51xIYdNtbNa"
    },
    "SG": {
      "amount": 0,
      "currency": "SGD",
      "id": "price_1NaqA8D2hzVtG51xjsFbAvf0"
    },
    "US": {
      "amount": 0,
      "currency": "USD",
      "id": "price_1NaqBtD2hzVtG51xXOuVMIAJ"
    }
  },
  "proofOfDelivery": true,
  "statusNotifications": false,
  "teamsAndZones": false,
} as unknown as EnrichedPlan
